import request from '@/utils/request'

// 查询赛事模板信息列表
export function listCompetitionTemplate(query) {
  return request({
    url: '/platform/competition-template/list',
    method: 'get',
    params: query
  })
}

// 查询赛事模板信息分页
export function pageCompetitionTemplate(query) {
  return request({
    url: '/platform/competition-template/page',
    method: 'get',
    params: query
  })
}

// 查询赛事模板信息详细
export function getCompetitionTemplate(data) {
  return request({
    url: '/platform/competition-template/detail',
    method: 'get',
    params: data
  })
}

// 新增赛事模板信息
export function addCompetitionTemplate(data) {
  return request({
    url: '/platform/competition-template/add',
    method: 'post',
    data: data
  })
}

// 修改赛事模板信息
export function updateCompetitionTemplate(data) {
  return request({
    url: '/platform/competition-template/edit',
    method: 'post',
    data: data
  })
}

// 删除赛事模板信息
export function delCompetitionTemplate(data) {
  return request({
    url: '/platform/competition-template/delete',
    method: 'post',
    data: data
  })
}
